import { render, staticRenderFns } from "./BranchSelectDialog.vue?vue&type=template&id=476b4beb&"
import script from "./BranchSelectDialog.vue?vue&type=script&lang=js&"
export * from "./BranchSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476b4beb')) {
      api.createRecord('476b4beb', component.options)
    } else {
      api.reload('476b4beb', component.options)
    }
    module.hot.accept("./BranchSelectDialog.vue?vue&type=template&id=476b4beb&", function () {
      api.rerender('476b4beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog.vue"
export default component.exports